import { AppRouteProps } from "@harea/component";
import React from "react";

const LoanListContainer = React.lazy(() => import("./container/LoanListContainer"));

export const LoanRoutes = [
    {
        path: "loans",
        element: <LoanListContainer />,
        title: "BSMRH.Loan.Title",
    },
] as Array<AppRouteProps>;